import img1 from "../assets/images/1.jpg";
import img2 from "../assets/images/2.jpg";
import img3 from "../assets/images/3.jpg";
import img4 from "../assets/images/4.jpg";
import img5 from "../assets/images/5.jpg";
import img6 from "../assets/images/6.png";
import img7 from "../assets/images/7.jpg";
import img8 from "../assets/images/8.jpg";
import img9 from "../assets/images/9.jpg";
import img10 from "../assets/images/10.jpg";
import img11 from "../assets/images/11.jpg";
import img12 from "../assets/images/12.jpg";

const CardList = [
  {
    id:1,
    describe:
      "Armchair",
    img: img1,
    cost: 200,
  },

  {
    id:2,
    describe:
      "Rocking Chair",
    img: img2,
    cost: 220,
  },
  {
    id:3,
    describe:
      "Recliner",
    img: img3,
    cost: 150,
  },
  {
    id:4,
    describe:
      "Barstool",
    img: img4,
    cost: 170,
  },
  {
    id:5,
    describe:
      "Wingback Chair",
    img: img5,
    cost: 185,
  },
  {
    id:6,
    describe:
      "Swivel Chair",
    img: img6,
    cost: 380,
  },
  {
    id:7,
    describe:
      "Folding Chair",
    img: img7,
    cost: 380,
  },
  {
    id:8,
    describe:
      "Eames Chair",
    img: img8,
    cost: 125,
  },
  {
    id:9,
    describe:
      "Dining Chair",
    img: img9,
    cost: 111,
  },
  {
    id:10,
    describe:"Womb Chair",
    img: img10,
    cost: 70,
  },
  {
    id:11,
    describe:
      "Adirondack Chair",
    img: img11,
    cost: 100,
  },
  {
    id:12,
    describe:
      "Banquette:",
    img: img12,
    cost: 112,
  },
];
export default CardList;
